import { ApiDeviceAdapter } from "./../interface/ApiDeviceAdapter";
import { ApiDeviceResponse } from "./../interface/ApiDeviceResponse";
export const apiDeviceAdapter = (device: ApiDeviceResponse): ApiDeviceAdapter =>
  device;
